import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Auth is guaranteed to be initialized by APP_INITIALIZER
  const isAuth = authService.isAuthenticated();
  
  if (isAuth) {
    return true;
  }

  window.location.href = 'https://app.messagefromheaven.com';
  return false;
};
